import React, { useState } from 'react';
import { Form } from 'react-bootstrap';
import TermsModal from './TermsModal';

interface TermsCheckboxProps {
  checked: boolean;
  onChange: (next: boolean) => void;
  className?: string;
  /** Smaller font + tighter spacing (used inside compact OTP cards). */
  compact?: boolean;
  id?: string;
}

/**
 * Reusable consent checkbox + linked Terms & Conditions modal.
 * Login / signup pages MUST use this and gate their submit buttons on `checked`.
 */
const TermsCheckbox: React.FC<TermsCheckboxProps> = ({
  checked,
  onChange,
  className,
  compact,
  id = 'terms-agree',
}) => {
  const [show, setShow] = useState(false);

  const fontSize = compact ? 12 : 14;

  return (
    <div className={className} style={{ display: 'flex', alignItems: 'flex-start', gap: 8 }}>
      <Form.Check
        type="checkbox"
        id={id}
        checked={checked}
        onChange={(e) => onChange(e.target.checked)}
        style={{ marginTop: 2 }}
      />
      <label
        htmlFor={id}
        style={{ fontSize, lineHeight: 1.4, color: '#374151', cursor: 'pointer', userSelect: 'none' }}
      >
        I have read and agree to the{' '}
        <button
          type="button"
          onClick={(e) => { e.preventDefault(); setShow(true); }}
          style={{
            background: 'none',
            border: 'none',
            padding: 0,
            color: '#0C831F',
            fontWeight: 700,
            textDecoration: 'underline',
            cursor: 'pointer',
            fontSize,
          }}
        >
          Terms &amp; Conditions
        </button>
      </label>
      <TermsModal
        show={show}
        onHide={() => setShow(false)}
        onAccept={() => onChange(true)}
      />
    </div>
  );
};

export default TermsCheckbox;

